import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqs } from '../data/faq';
import { Emoji } from './Emoji';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-canvas py-14 sm:py-16" data-id="element-78" data-mp="1lcacf2uyo51b">
      <div className="mx-auto w-full max-w-[680px] px-4 sm:px-6 lg:max-w-[820px]" data-id="element-79" data-mp="1gd7iadgirj84">
        <h2 className="flex w-full flex-wrap items-center justify-center gap-2 text-center font-display text-[clamp(1.5rem,6vw,2.25rem)] font-extrabold uppercase leading-[1.08] tracking-tight text-ink-900" data-id="element-80" data-mp="2e0fvzmaa3nzk">
          <Emoji symbol="❓" className="text-3xl" data-id="element-81" data-mp="242077pyq4qt8" />
          Lo que más nos preguntan
        </h2>

        <ul className="mt-9 flex flex-col gap-3" data-id="element-82" data-mp="1z3ff6dtmldfv">
          {faqs.map((item, index) => {
          const isOpen = openIndex === index;
          return <li key={item.question} className="overflow-hidden rounded-2xl border border-line bg-white shadow-card" data-id="element-83" data-mp="soegi0d7uh5l" data-mpi={index}>
                <h3 data-id="element-84" data-mp="pizf3w92p2fb">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left font-display text-[14px] font-bold text-ink-900 transition-colors duration-150 ease-out hover:text-celeste-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-celeste-600 sm:gap-5 sm:px-5 sm:py-5 sm:text-lg" data-id="element-85" data-mp="pipme0wn8h5x">
                    <span className="min-w-0" data-id="element-86" data-mp="3szprqtz5udpz">{item.question}</span>
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-celeste-200" data-id="element-87" data-mp="1s3naz4ma782">
                      {isOpen ? <MinusIcon className="h-4 w-4 text-celeste-800" aria-hidden="true" data-id="element-88" data-mp="3jyrt6r7hqyes" /> : <PlusIcon className="h-4 w-4 text-celeste-800" aria-hidden="true" data-id="element-89" data-mp="1ui5q1v1zlhh5" />}
                    </span>
                  </button>
                </h3>
                <div id={`faq-panel-${index}`} hidden={!isOpen} className="border-t border-line px-4 py-4 text-[14px] leading-relaxed text-ink-700 sm:px-5 sm:py-5 sm:text-[15px]" data-id="element-90" data-mp="1fsq2enxr5s5o">
                  {item.answer}
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}